import React from 'react'
import '../styles/About.css'
import { NavLink } from 'react-router-dom'

import katiaDoodleToys from '../lettering/katia_doodle_toys.svg';
import obo_mne from '../lettering/obo_mne.svg'
import lisa_na_ruke from '../images/lisa_na_ruke.jpg'
import nazad from '../icons/nazad.svg'

const About = () => {
  return (
    <section className="About">
        {/* <NavLink className={'aboutGoBack'} to="/"> <img src={nazad} alt="Назад" className='aboutGoBackImg' /> </NavLink> */}
        <div className="aboutContent">
            <img src={katiaDoodleToys} alt="Doodle Toys Orange" className="aboutHeaderImg" />
            <img src={obo_mne} alt="Обо мне" className="aboutObo_mne" />
            <div className="aboutText">
            Привет!<br/>
Меня зовут Катя Шумкова, я — художник из Москвы. 
На этом сайте вы сможете увидеть различные 
предметы моего авторства.<br/><br/>
<span className='aboutUnderline'>Doodle toys</span> — это серия фигурок из ткани, в основе 
которой лежат “дудлы”, наброски нарисованных 
мной персонажей.<br/>
Материалами для создания “дудлов” служат 
лоскуты ткани, нитки, синтепух. Они очень легкие 
и мягкие, невелики ростом, в среднем 10-15 см.<br/>
Эти фигурки могут стать уникальными брошками, 
украшениями на елку, декором для интрерьера 
или просто вашими талисманами.<br/> 
Пишите мне по любым вопросам о предметах 
и возможности приобретения!
        </div>
        <NavLink className={'aboutGoBack'} to="/"> <img src={nazad} alt="Назад" className='aboutGoBackImg' /> </NavLink>
        </div>
        <img src={lisa_na_ruke} alt="Лиса" className="aboutFox" />
    </section>
  )
}

export default About